import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'checkbox-container',
    templateUrl: './checkbox-container.component.html',
    providers: []
})
export class CheckboxContainerComponent implements OnInit, AfterViewInit{

    @Input() id;
    @Input() name;
    @Input() label;
    @Input() size;
    @Input() invalid;
    @Input() invalidText;
    @Input() disabled:boolean=false;
    @ViewChild("wccheckbox", {read: ElementRef}) child: ElementRef;
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    modelValue:boolean = false;
    @Output() modelChange:EventEmitter<any> = new EventEmitter<any>();
    isChecked:boolean=false;

    @Input()
    get model() {
        return this.modelValue;
    }

    set model(val) {
        this.modelValue = val;
        this.modelChange.next(this.modelValue);
        this.isChecked = !val?false:true;
    }

    ngAfterViewInit(): void {
        if(!!this.disabled)
            this.child.nativeElement.setAttribute("disabled", true)
        this.child.nativeElement.addEventListener("change",(event) => {
            this.modelValue = event.target.checked;
            this.isChecked = this.modelValue;
            this.modelChange.next(this.modelValue);
            if(!!this.onChange){
                this.onChange.emit();
            }
        });
    }

    ngOnInit(): void {
        this.invalid=false;
        if(!!this.model){
            this.isChecked = this.model;
        }
        this.disabled= !!this.disabled?this.disabled:false;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/checkbox-container/checkbox-container.component.ts